export const validatePassword = (password: string): boolean => {
  const pattern = /^(?=.*[a-zA-Z\d])(?=.*[\W_]).{8,}$/;
  return pattern.test(password);
};
